import { getMyTenantProfileUrl } from "@rentiohq/shared-frontend/dist/utils/url.utils";
import { EAssets } from "../assets";
import { EMenuItems } from "./types";
var menuItems = [
    {
        id: EMenuItems.Welcome,
        title: "dashboard.welcome",
        icon: EAssets.CalendarIcon,
        url: "",
        matchPaths: ["/"],
        breadcrumbs: true,
    },
    {
        id: EMenuItems.Property,
        title: "system.properties",
        icon: EAssets.HouseIcon,
        url: "/properties",
        matchPaths: [
            "/properties",
            "/properties/:propertyId/",
            "/properties/:propertyId/contracts",
            "/properties/:propertyId/documents",
            "properties/:propertyId/history",
        ],
        breadcrumbs: true,
    },
    {
        id: EMenuItems.Contacts,
        title: "system.contacts",
        icon: EAssets.UserOutlinedIcon,
        url: "/contacts",
        matchPaths: ["/contacts"],
        breadcrumbs: true,
    },
    {
        id: EMenuItems.Applications,
        title: "system.entity.applications",
        icon: EAssets.ApplicationIcon,
        url: getMyTenantProfileUrl({}),
        matchPaths: ["applications"],
        breadcrumbs: true,
        target: "_blank",
        openModal: true,
        message: "tenant_dashboard.see_applications.modal.message",
    },
    {
        id: EMenuItems.Payments,
        title: "payments_overview.heading",
        icon: EAssets.EuroIcon,
        url: "/payments",
        matchPaths: [
            "/payments",
            "/payment/:paymentRequestId",
            "/payment/:paymentRequestId/status",
            "/payment/:paymentRequestId/payment-method",
            "/payment/:paymentRequestId/payment-method/mangopay",
            "/payment/:paymentRequestId/payment-method/mangopay/add-iban",
            "/payment/:paymentRequestId/payment-method/ibanisation",
            "/payment/:paymentRequestId/payment-method/:paymentMethod/payment-limit",
        ],
        breadcrumbs: true,
    },
    {
        id: EMenuItems.Tasks,
        title: "system.tasks",
        icon: EAssets.TasksIcon,
        url: "/tasks",
        matchPaths: ["tasks"],
        breadcrumbs: true,
    },
    {
        id: EMenuItems.Chats,
        title: "system.entity.chats",
        icon: EAssets.ChatsIcon,
        url: "/chats",
        matchPaths: ["chats"],
        breadcrumbs: true,
    },
];
// eslint-disable-next-line import/no-default-export
export default menuItems;
